import { render, staticRenderFns } from "./SCCard.vue?vue&type=template&id=f91fa5e2&scoped=true&"
var script = {}
import style0 from "./SCCard.vue?vue&type=style&index=0&id=f91fa5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91fa5e2",
  null
  
)

export default component.exports